import { __assign, __generator } from "tslib";
import { all, select, put, takeLatest, takeEvery, take, } from 'redux-saga/effects';
import { setCompliantLocalStorageItem } from '../../redux/compliantLocalStorage/actions';
import { CompliantLocalStorageKeys } from '../../redux/compliantLocalStorage/constants';
import { getStorageEventChannel } from '../../redux/compliantLocalStorage/utils';
import { convertToClientStorageState } from '../../DaEditorWrapper/utils';
import { userLogoutButtonClicked } from '../../SiteHeader/redux/actions';
import { appMounted } from '../../redux/app/actions';
import { saveEditorDraft, removeEditorDraft, uploadDraggedFile, } from './actionCreators';
import { getEditorDraftsState } from './selectors';
import { EDITOR_DRAFT_EXPIRATION_DELTA } from './constants';
import { fetchDeviation } from '../../redux/deviations/actionCreators';
import { uploadFile } from '../../redux/uploads/actions';
function cleanExpiredDrafts(draftsState) {
    var newState = {};
    for (var editorId in draftsState) {
        var updatedAt = draftsState[editorId].updatedAt;
        var minUpdatedDate = Date.now() - EDITOR_DRAFT_EXPIRATION_DELTA;
        if (updatedAt >= minUpdatedDate) {
            newState[editorId] = draftsState[editorId];
        }
    }
    return newState;
}
function saveEditorDraftHandler(_a) {
    var data, draftsState, mergedDraftsState;
    var _b;
    var _c = _a.payload, editorId = _c.editorId, editorState = _c.editorState;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!editorState) {
                    return [2 /*return*/];
                }
                data = {
                    textContent: convertToClientStorageState(editorState.rawContentState, editorState.editorContent, editorState.features).editorText,
                    updatedAt: Date.now(),
                };
                return [4 /*yield*/, select(getEditorDraftsState) || {}];
            case 1:
                draftsState = _d.sent();
                mergedDraftsState = __assign(__assign({}, cleanExpiredDrafts(draftsState)), (_b = {}, _b[editorId] = data, _b));
                return [4 /*yield*/, put(setCompliantLocalStorageItem({
                        key: CompliantLocalStorageKeys.EDITOR_DRAFTS,
                        value: JSON.stringify(mergedDraftsState),
                    }))];
            case 2:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
function removeEditorDraftHandler(_a) {
    var draftsState;
    var editorId = _a.payload.editorId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getEditorDraftsState) || {}];
            case 1:
                draftsState = _b.sent();
                delete draftsState[editorId];
                return [4 /*yield*/, put(setCompliantLocalStorageItem({
                        key: CompliantLocalStorageKeys.EDITOR_DRAFTS,
                        value: JSON.stringify(draftsState),
                    }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function uploadDraggedFileHandler(_a) {
    var onSuccess, onFailure, dispatchedAction, fileId, blockKey;
    var _b = _a.payload, file = _b.file, uploadHelpers = _b.uploadHelpers;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                onSuccess = function (_a) {
                    var deviationId = _a.deviationId;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, put(fetchDeviation({
                                    deviationid: deviationId,
                                    type: 'art',
                                    onSuccess: function (deviation) {
                                        blockKey && uploadHelpers.attachDeviation(deviation, blockKey);
                                    },
                                }))];
                            case 1:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                onFailure = function () {
                    // TODO: handle upload failure
                };
                return [4 /*yield*/, put(uploadFile({
                        file: file,
                        onSuccess: onSuccess,
                        onFailure: onFailure,
                    }))];
            case 1:
                dispatchedAction = _c.sent();
                fileId = dispatchedAction.payload.fileId;
                blockKey = uploadHelpers.attachUpload(fileId);
                return [2 /*return*/];
        }
    });
}
function handleAppMounted() {
    var channel, event_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                channel = getStorageEventChannel();
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, take(channel)];
            case 2:
                event_1 = _a.sent();
                if (event_1.key !== CompliantLocalStorageKeys.EDITOR_DRAFTS ||
                    !event_1.newValue) {
                    return [3 /*break*/, 1];
                }
                return [4 /*yield*/, put(setCompliantLocalStorageItem({
                        key: CompliantLocalStorageKeys.EDITOR_DRAFTS,
                        value: event_1.newValue,
                    }))];
            case 3:
                _a.sent();
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
function handleUserLogout() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // On logout clear drafts to avoid leaking data
            return [4 /*yield*/, put(setCompliantLocalStorageItem({
                    key: CompliantLocalStorageKeys.EDITOR_DRAFTS,
                    value: JSON.stringify({}),
                }))];
            case 1:
                // On logout clear drafts to avoid leaking data
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(saveEditorDraft, saveEditorDraftHandler),
                    takeLatest(removeEditorDraft, removeEditorDraftHandler),
                    takeEvery(uploadDraggedFile, uploadDraggedFileHandler),
                    takeEvery(appMounted, handleAppMounted),
                    takeEvery(userLogoutButtonClicked, handleUserLogout),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map